import { render, staticRenderFns } from "./AppImagePreview.vue?vue&type=template&id=1af5ba38&scoped=true"
import script from "./AppImagePreview.vue?vue&type=script&lang=js"
export * from "./AppImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5ba38",
  null
  
)

export default component.exports